module.exports = __webpack_public_path__ + "f429ba23687f5fe1cd875c3ee6b57c31.svg";